import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { ListRow } from './ListRow';
import { StatusBadge, type StatusTone } from './StatusBadge';

export type SettingRowProps = {
  title: string;
  value?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  visual?: ReactNode;
  showVisualOnMobile?: boolean;
  statusLabel?: string;
  statusTone?: StatusTone;
  ariaLabel?: string;
  compact?: boolean;
  onClick?: () => void;
};

/** 설정 화면은 범용 ListRow의 배치와 동작을 사용하고 설정용 아이콘·상태만 조합합니다. */
export function SettingRow({ title, value, description, icon, visual, showVisualOnMobile = false, statusLabel, statusTone = 'neutral', ariaLabel, compact = false, onClick }: SettingRowProps) {
  return <ListRow
    label={title} value={value} description={description} ariaLabel={ariaLabel} density={compact ? 'compact' : 'standard'} onClick={onClick}
    icon={icon ? <Box sx={{
      width: designTokens.layout.settingRowIconSize, height: designTokens.layout.settingRowIconSize,
      borderRadius: designTokens.radius.surface, bgcolor: designTokens.color.accentSoft, color: designTokens.color.accentText,
      display: 'grid', placeItems: 'center',
    }}>{icon}</Box> : undefined}
    trailing={visual || statusLabel ? <>
      {visual ? <Box aria-hidden sx={{ display: { xs: showVisualOnMobile ? 'block' : 'none', sm: 'block' }, minWidth: 0, maxWidth: '100%' }}>{visual}</Box> : null}
      {statusLabel ? <StatusBadge label={statusLabel} tone={statusTone} /> : null}
    </> : undefined}
  />;
}
